/** @deprecated Ribbons consumers should not rely on a Ribbons component's internal implementation details */
export var BUTTON__CONTENT_CLASS = 'button__content';
export var SPINNER_CLASSNAME_PREFIX = 'ribbons-solid-button';